import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {breadcrumbRoutes} from "../config/breadcrumbRoutes";

const BreadcrumbContext = createContext();

export const useBreadcrumb = () => useContext(BreadcrumbContext);

export const BreadcrumbProvider = ({ children }) => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const currentPath = location.pathname;

    // Find best match (handles dynamic routes)
    const matchedRoute = breadcrumbRoutes.find(route => {
      const routePattern = new RegExp(
        "^" + route.path.replace(/:[^/]+/g, "[^/]+") + "$"
      );
      return routePattern.test(currentPath);
    });

    const pathnames = currentPath.split("/").filter(x => x);
    const crumbs = pathnames.map((segment, index) => {
      const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
      const customMatch = breadcrumbRoutes.find(route => {
        const routePattern = new RegExp(
          "^" + route.path.replace(/:[^/]+/g, "[^/]+") + "$"
        );
        return routePattern.test(routeTo);
      });

      return {
        name:
          customMatch?.name ||
          segment.charAt(0).toUpperCase() + segment.slice(1),
        path: routeTo,
      };
    });

    setBreadcrumbs(crumbs);
  }, [location]);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
